var map = {
	"./flaticon-norway.png": 1361,
	"./flaticon-portugal.png": 47437,
	"./flaticon-spain.png": 19248,
	"./flaticon-turkiye.png": 71752,
	"./flaticon-uk.png": 36023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12984;